import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export interface AuthRegisterServiceInput {
  accessCode?: string
  name?: string
  lastName?: string
  email?: string
  password?: string
}

export const authRegisterService = async ({
  name,
  email,
  password,
  lastName,
  accessCode,
}: AuthRegisterServiceInput) => {
  const { data } = await api.post<ResponseAPI>('cadastro', {
    codigoAcesso: accessCode,
    cnpjCpf: '',
    nome: name,
    sobrenome: lastName,
    usuario: email.toLowerCase(),
    senha: password,
  })

  return data
}
